export const isAuthenticated = state => {
  const { user } = state;
  return !user.isLoading && user.data.state === 'active';
};